import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function noTradingOnPreMarketCandlesBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        This setup currently does not support pre-market candles. Regular-hours
        candle handling still applies here.{' '}
      </Body3>
    </td>
  );
}
